/* eslint react/no-danger: 0 */ // --> Need to set innerHtml for the formatted description...
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Analytics } from 'packages';
import { Spinner, QuickViewCarousel, Shimmer, DialogModal } from 'components';
import STRINGS from 'constants/strings';
import uiActions from 'state/actions/ui';
import itemActions from 'state/actions/items';
import ITEM_TYPES from 'constants/item-types';
import './quick-view-modal.scss';
import 'moment/locale/sv';
import moment from 'moment';
import HeartIcon from '@tradera/tradera-ui/icons/heart.svg?jsx';
import ArrowLeftIcon from '@tradera/tradera-ui/icons/arrow-left.svg?jsx';
import ArrowRightIcon from '@tradera/tradera-ui/icons/arrow-right.svg?jsx';

moment.locale('sv');

class QuickView extends Component {
    static propTypes = {
        itemIds: PropTypes.array.isRequired,
        open: PropTypes.string,
        item: PropTypes.object,
        currentItem: PropTypes.number,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            fetching: false
        };
    }

    closeQuickView = () => this.props.dispatch(uiActions.closeQuickView());

    handleWishlistClick = () => {
        const { dispatch, item, isLoggedIn } = this.props;
        if (!isLoggedIn) {
            this.closeQuickView();
        }
        dispatch(itemActions.wishlist(item.itemId));
    };

    handlePreviousClick = () => {
        const { dispatch, itemIds, currentItem } = this.props;
        const prevItem = itemIds[itemIds.indexOf(currentItem) - 1];
        dispatch(uiActions.openQuickView({ itemId: prevItem }));
        Analytics.trackEvent({
            category: 'Quick View',
            action: 'Navigation',
            label: 'Previous'
        });
    };

    handleNextClick = () => {
        const { dispatch, itemIds, currentItem } = this.props;
        const nextItem = itemIds[itemIds.indexOf(currentItem) + 1];
        dispatch(uiActions.openQuickView({ itemId: nextItem }));

        Analytics.trackEvent({
            category: 'Quick View',
            action: 'Navigation',
            label: 'Next'
        });
    };

    fetchItem = itemId => {
        this.setState({
            fetching: true
        });
        const { dispatch } = this.props;
        dispatch(uiActions.openQuickView({ itemId }));
        this.setState({
            fetching: false
        });
    };

    renderBinPriceInfo = fixedPrice => (
        <div className="d-flex flex-column justify-content-between align-center price-meta py-4 px-3">
            <div className="mb-2">{STRINGS.PRICE}</div>
            <div className="display-4 mb-3 font-weight-bold">{`${fixedPrice ||
                ''} kr`}</div>
        </div>
    );

    renderAuctionPriceInfo = item => {
        const { leadingBid, openingBid, bidCount, endDate } = item;
        const endTime = moment(endDate).format('D MMM HH:mm');
        const timeLeft = moment(endDate).fromNow(true);
        return (
            <div className="d-flex justify-content-between price-meta py-4 px-3">
                <div className="d-flex flex-column">
                    <p>{bidCount > 0 ? 'Ledande bud' : 'Utropspris'}</p>
                    <p className="display-4 font-weight-bold">
                        {`${leadingBid || openingBid || ''} kr`}
                    </p>
                </div>
                <div className="d-flex flex-column">
                    <p>{`${STRINGS.ENDS} ${endTime || ''}`}</p>
                    <p className="display-4 font-weight-bold">
                        {timeLeft || ''}
                    </p>
                </div>
                <div className="d-flex flex-column">
                    <p>{STRINGS.BIDS}</p>
                    <p className="display-4 font-weight-bold">{`${bidCount ||
                        '0'} st`}</p>
                </div>
            </div>
        );
    };

    renderButtonSection = url => {
        const { item } = this.props;
        const isInWishList = item.existsInWishList;
        return (
            <div className="d-flex flex-column">
                <button
                    className={`btn btn-fluid btn--icon-fixed my-2 ${
                        isInWishList ? 'btn-success' : 'btn-outline-dark'
                    }`}
                    onClick={() => this.handleWishlistClick()}>
                    <HeartIcon
                        className={`icon icon-lg icon-before ${
                            isInWishList ? 'icon-danger' : 'icon-secondary'
                        }`}
                    />
                    {isInWishList
                        ? 'Sparad i minneslistan'
                        : 'Spara i minneslistan'}
                </button>
                <a
                    href={url}
                    className="btn btn-primary mt-2"
                    onClick={() => {
                        Analytics.trackEvent({
                            category: 'Quick View',
                            action: 'Navigation',
                            label: 'View full listing'
                        });
                    }}>
                    {STRINGS.VIEW_FULL_LISTING}
                </a>
            </div>
        );
    };

    createLongDescription = longDescription => {
        return { __html: longDescription };
    };

    renderQuickViewBody = (quickViewItem, currentItem) => {
        const { itemIds } = this.props;
        const {
            shortDescription,
            longDescription,
            imageFormats,
            url,
            fixedPrice,
            itemType
        } = quickViewItem;
        const disableNext = itemIds.indexOf(currentItem) === itemIds.length - 1;
        const disablePrev = itemIds.indexOf(currentItem) < 1;
        return (
            <div
                className="quick-view"
                onKeyDown={e => {
                    if (e.keyCode === 27) {
                        this.closeQuickView();
                    } else if (e.keyCode === 39 && !disableNext) {
                        this.handleNextClick();
                    } else if (e.keyCode === 37 && !disablePrev) {
                        this.handlePreviousClick();
                    }
                }}>
                <div className="modal-body p-5 d-flex flex-column justify-content-between">
                    <div className="row d-flex justify-content-between">
                        <div className="display-4 font-weight-bold text-truncate">
                            {shortDescription || ''}
                        </div>
                        <button
                            className="modal-close icon icon--close text-dark"
                            onClick={e => {
                                this.closeQuickView();
                                e.stopPropagation();
                            }}
                        />
                    </div>
                    <div className="row pt-3">
                        <div className="col pr-4">
                            {!imageFormats ? (
                                <Shimmer
                                    width={515}
                                    height={396}
                                    classNames="d-block quick-view-modal-shimmer"
                                />
                            ) : (
                                <QuickViewCarousel
                                    images={imageFormats}
                                    pageType={'Quick View'}
                                    carouselStyle={{
                                        maxWidth: '515px',
                                        minWidth: '515px'
                                    }}
                                />
                            )}
                        </div>
                        <div className="quick-view--right-wrapper col d-flex flex-column justify-content-between">
                            {imageFormats ? (
                                itemType === ITEM_TYPES.PURE_BIN ||
                                itemType === ITEM_TYPES.SHOP_ITEM ? (
                                    this.renderBinPriceInfo(fixedPrice)
                                ) : (
                                    this.renderAuctionPriceInfo(quickViewItem)
                                )
                            ) : (
                                <Shimmer
                                    width={305}
                                    height={84}
                                    classNames="d-inline-block"
                                />
                            )}
                            <div className="description pt-5 d-flex flex-column">
                                <div className="display-4 font-weight-bold">
                                    {STRINGS.DESC}
                                </div>
                                <div
                                    className="d-inline-block description--long-desc mb-3"
                                    dangerouslySetInnerHTML={this.createLongDescription(
                                        longDescription
                                    )}
                                />
                                <a
                                    href={url}
                                    onClick={() => {
                                        Analytics.trackEvent({
                                            category: 'Quick View',
                                            action: 'Navigation',
                                            label: 'View full description'
                                        });
                                    }}>
                                    {STRINGS.SHOW_FULL_DESC}
                                </a>
                            </div>
                            {this.renderButtonSection(url)}
                            <div className="d-flex justify-content-between navigation-buttons">
                                <button
                                    className="btn btn-fluid btn-previous btn--icon-fixed"
                                    onClick={e => {
                                        this.handlePreviousClick();
                                        e.stopPropagation();
                                    }}
                                    disabled={disablePrev}
                                    autoFocus={disableNext}>
                                    <ArrowLeftIcon className="icon icon-before icon-dark" />
                                    <span>{STRINGS.PREVIOUS}</span>
                                </button>
                                <button
                                    className="btn btn-fluid btn-next btn--icon-fixed"
                                    onClick={e => {
                                        this.handleNextClick();
                                        e.stopPropagation();
                                    }}
                                    disabled={disableNext}
                                    autoFocus={!disableNext}>
                                    {STRINGS.NEXT}
                                    <ArrowRightIcon className="icon icon-after icon-dark" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderQuickViewLoading = () => (
        <div className="quick-view">
            <div className="modal-body d-flex flex-column justify-content-between">
                <Spinner className="quick-view__spinner" />
            </div>
        </div>
    );

    render() {
        const { open, item, currentItem } = this.props;
        if (open !== 'open') {
            return null;
        }
        const { fetching } = this.state;

        return (
            <DialogModal
                mediaQuery={{ minWidth: 1024 }}
                onDismiss={() => this.closeQuickView()}>
                {fetching || !item
                    ? this.renderQuickViewLoading()
                    : this.renderQuickViewBody(item, currentItem)}
            </DialogModal>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const addUrlTracking = item => {
        if (!item || !item.url) return item;
        item.url += `?itm_source=quick-view`;
        return item;
    };
    return {
        itemIds: state.ui.quickView.itemIds,
        open: state.ui.quickView.open,
        isLoggedIn: state.initData.isLoggedIn,
        item:
            addUrlTracking(state.items[state.ui.quickView.currentItem]) || null,
        currentItem: state.ui.quickView.currentItem,
        ...ownProps
    };
};

export default connect(mapStateToProps)(QuickView);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/quick-view/quick-view-modal.jsx